import { useSubscription } from '@apollo/client';

import { ActivitiesContentType } from 'global/constants';
import { JOIN_LIVE_CLASSROOM_SUBSCRIPTION } from './join-live-classroom.graphql';
import type {
  JoinLiveClassroomSubscription,
  JoinLiveClassroomSubscriptionVariables,
} from './join-live-classroom.graphql.generated';

type Props = {
  classId: number | null;
  contentType: ActivitiesContentType;
  contentVersion: string;
  skip?: boolean;
};

export const useJoinLiveClassroomSubscription = ({
  classId,
  contentType,
  contentVersion,
  skip = false,
}: Props) => {
  const subscription = useSubscription<
    JoinLiveClassroomSubscription,
    JoinLiveClassroomSubscriptionVariables
  >(JOIN_LIVE_CLASSROOM_SUBSCRIPTION, {
    skip: !classId || !contentVersion || skip,
    variables: {
      input: {
        classId: classId!,
        contentType,
        contentVersion,
      },
    },
  });

  return subscription;
};
